<template>
  <section id="paynetThanks">
    <div class="ps card border border-success" v-if="$route.params.validate === true">
      <div class="ps-header">
        <div class="ps-reminder bg-dark">Ficha digital. No es necesario imprimir.</div>
        <div class="ps-reference pt-5 pb-2">
          	<h3 class="pb-4 text-success">FELICIDADES !!!</h3>
			  <div class="check-wrap"></div>
          	<p class="m-0 pt-3">Tu # de referencia se ha generado.</p>
			</p>
        </div>
      </div>
      <div class="ps-instructions">
        <div class="ps-footnote p-3">
          Al confirmar tu pago recibirás un correo de <strong>MMK Group</strong> confirmando
          tu pago y tu pedido.
        </div>
      </div>
    </div>
	<div class="emptyHtml" v-else>
	</div>
  </section>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'thanksForPay',
	components: {
	},
    data(){
        return {
        }
    },
	mounted() {
		// Inicia la pagina arriba
         $(window).scrollTop(0);
		//  Checa si la pagina viene del flujo correcto, si no te envia a la ruta principsl
		(this.$route.params.validate) ? "" : location.href = "/";

          window.dataLayer.push({
            'event': 'productoCompradoEnEsperaPago',
            'pageURL': this.$router.currentRoute.fullPath,
            'product': this.$route.params.products,
            'referenceDateGenerated': new Date().toLocaleString('en-US')
          });
	}
}
</script>

<style lang="scss" scoped>
#paynetThanks .emptyHtml{
	min-height: 50vh;
	opacity:0;
}

#paynetThanks .ps {
	margin:8% auto;
}
#paynetThanks .check-wrap {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 2px solid #28a745;
	position: relative;
	overflow: hidden;
	animation: wrap 0.3s ease-in-out forwards;
	animation-delay: 0.3s;
	transform: scale(0);
	margin:auto;
}
#paynetThanks .check-wrap::before, .check-wrap::after {
	content: "";
	position: absolute;
	background-color: white;
	width: 0;
	height: 5px;
	transform-origin: left;
	animation-duration: 0.3s;
	animation-timing-function: ease-in-out;
	animation-fill-mode: forwards;
	animation-iteration-count: 2;
}
#paynetThanks .check-wrap::before {
	top: 32px;
	left: 21px;
	transform: rotate(45deg);
	animation-name: left;
	animation-delay: 0.8s;
}
#paynetThanks .check-wrap::after {
	top: 42px;
	left: 29px;
	transform: rotate(-45deg);
	animation-name: right;
	animation-delay: 1.1s;
}

@keyframes wrap {
  0% {
    background-color: transparent;
    transform: scale(0);
  }
  100% {
    background-color: #28a745;
    transform: scale(1);
  }
}
@keyframes left {
  0% {
    width: 0;
  }
  100% {
    width: 15px;
  }
}
@keyframes right {
  0% {
    width: 0;
  }
  100% {
    width: 30px;
  }
}
li{
	padding: 1% 0;
}

@media (max-width: 576px) {
	#paynetThanks .ps {
    	max-width: 496px;
		width:100%;
	}
	#paynetThanks .ps-brand img {
		max-width: 120px;
	}
	#paynetThanks h3{
		font-size:2rem;
	}
	#paynetThanks .ps-instructions {
    	padding: 32px 20px 45px;
	}
	#paynetThanks .ps-reference h1{
		font-size: 1.3rem;
	}
}
</style>
